/**
 * <s-phone-finder> — Brand → model → collection routing.
 * Filters the model <select> to the chosen brand and navigates to the
 * selected model's collection URL on submit. Model <option> values are
 * collection URLs written by Liquid; each carries data-brand.
 */
class SPhoneFinder extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const form = this.querySelector('form');
    const brand = this.querySelector('[data-brand-select]');
    const model = this.querySelector('[data-model-select]');
    if (!form || !brand || !model) return;

    // Keep a pristine copy so filtering can restore options removed earlier.
    this.options = Array.from(model.querySelectorAll('option[data-brand]')).map((o) => o.cloneNode(true));

    brand.addEventListener('change', () => this.#filter(brand, model), { signal });
    model.addEventListener('change', () => this.#sync(model), { signal });
    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        if (model.value) {
          window.location.href = model.value;
        } else {
          model.focus();
        }
      },
      { signal },
    );

    this.#filter(brand, model);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #filter(brand, model) {
    const placeholder = model.querySelector('option:not([data-brand])');
    model.replaceChildren(...(placeholder ? [placeholder] : []));
    const selected = brand.value;
    this.options
      .filter((o) => !selected || o.dataset.brand === selected)
      .forEach((o) => model.append(o.cloneNode(true)));
    model.value = '';
    this.#sync(model);
  }

  #sync(model) {
    const button = this.querySelector('[data-finder-submit]');
    if (button) button.toggleAttribute('data-ready', Boolean(model.value));
  }
}

if (!customElements.get('s-phone-finder')) customElements.define('s-phone-finder', SPhoneFinder);
